import { Box, Grid, Typography } from '@mui/material';
import { useStyles } from '../style';
import _ from 'lodash';
import { PageContainer, PriceLabel } from 'components';
import { numberWithCommas } from 'utility';
import { useState } from 'react';
import InitFilteringReportSummary from '../constants/InitFilteringReportSummary';
import { toFilterVOS } from 'components/FilterPod';
import { FilterPod, ExportButton } from 'components';
import { useExportFile , useCurrencyUnit } from 'hooks';
import ImprestServices from '../../services/ImprestServices';
import { NewLoading } from 'components';
import FilterButton from 'components/FilterPod/FilterButton';
import {getExportImprestUrl} from 'URLs';
export default function ImprestReportSummary() {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(InitFilteringReportSummary);
  const [filterParams, setFilterParams] = useState(null);
  const classes = useStyles();
  const [data, setData] = useState(null);
  const { downloadFile, isExporting } = useExportFile({
    url: getExportImprestUrl(),
    filename: 'report-imprest',
  });
  const currencyText = useCurrencyUnit();  
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const filterVOStoQueryStrWithId = (filters) => {
    const queries = {};
    filters.forEach((v) => {
      if (v?.value != null) {
        const k = v?.id ?? null;
        if (k) {
          queries[k] = v?.value;
        }
      }
    });
    return queries;
  };
  const getData = () => {
    setLoading(true);
    let filter = toFilterVOS([...filters]);
    let queries = filterVOStoQueryStrWithId(filter);

    let params = {
      ...queries,
    };

    const data = {
      filterVOS: [],
      parentParams: [],
      orderByElementVOS: [],
    };
    setFilterParams({ data, params });
    ImprestServices.getReportSummary(data, params)
      .then((res) => {
        const d = generateData(res?.result?.rows[0]);
        setData(d);
        setLoading(false);
      })
      .catch((error) => {

        setLoading(false);
      });
  };

  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    getData();
  };
  const onChangeTemp = (f) => {
    setFilters(f);

  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  const generateData = (row, query) => {
    const newData = {
      allTransaction: row.cols[0], // تعداد کل تراکنش
      sumDiscount: row.cols[1], // مجموع واریز
      sumWidraw: row.cols[2], // مجموع برداشت
      balanceNotUse: row.cols[3], // مانده اعتبار مصرف نشده
      balanceRial: row.cols[4], // مانده 
      sumUsable: row.cols[5], // مجموع قابل مصرف
      totalAmount: row.cols[6], // مبلغ کل اعتبار تخصیص شده
    };
    return newData;
  };

  const hint = 'محدوده تاریخ حداکثر 3 ماه گذشته می باشد.جهت نمایش گزارش، پس از انتخاب بازه زمانی مورد نظر بر روی دکمه جستجو کلیک نمایید.';

  return (
    <PageContainer
      title="گزارش تجمیعی"
      className={classes.root}
      description={hint}
    >
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={filters}
          />
          <ExportButton
            loading={isExporting}
            types={['xls', 'csv']}
            onExport={onExport}
          />
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            onChangeTemp={onChangeTemp}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>

      <Grid container direction="row" alignItems="center" item>
        <Grid item xs={12}>
          {loading ? (
            <Grid container xs={12} md={12} style={{ position: 'relative', minHeight: '200px' }}>
              <NewLoading />
            </Grid>
          ) : (
            <>
              <Grid container xs={12} md={12} className={classes.info}>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>تعداد کل تراکنش</Typography>
                  <Typography className={classes.detailValue}>
                    {numberWithCommas(data?.allTransaction) || '-'}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مجموع واریز</Typography>
                  <Typography className={classes.detailValue}>
                    <PriceLabel amount={data?.sumDiscount} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مجموع برداشت</Typography>
                  <Typography className={classes.detailValue}>
                     <PriceLabel amount={data?.sumWidraw} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مانده {currencyText}ی </Typography>
                  <Typography className={classes.detailValue}>
                     <PriceLabel amount={data?.balanceRial} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مانده اعتبار مصرف نشده </Typography>
                  <Typography className={classes.detailValue}>
                    <PriceLabel amount={data?.balanceNotUse} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>
                    مجموع قابل مصرف (نقد و اعتبار){' '}
                  </Typography>
                  <Typography className={classes.detailValue}>
                     <PriceLabel amount={data?.sumUsable} />
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مبلغ کل اعتبار تخصیص شده </Typography>
                  <Typography className={classes.detailValue}>
                     <PriceLabel amount={data?.totalAmount} />
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}



        </Grid>
      </Grid>
    </PageContainer>
  );
}
